// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RolesAndPermissions.css */
.roles-permissions-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    background-color: rgba(0, 123, 255, 0.1); /* Прозрачный фон */
  }
  
  .top-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .roles-list-section,
  .permissions-list-section {
    width: 30%;
    padding-right: 10px;
  }
  
  .role-details-section {
    width: 40%;
  }
  
  .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
  }
  
  .section-header h2 {
    color: rgb(0, 123, 255);
    margin-bottom: 0;
  }
  
  .create-button {
      background-color: rgb(0, 123, 255);
      color: white;
      border: none;
      padding: 8px 15px;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.3s;
  }
  
  .create-button:hover {
      background-color: rgba(0, 123, 255, 0.8);
  }
  
  .user-role-assignment-section {
    width: 100%;
    margin-top: 20px;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Admin/components/RolesAndPermissions.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,wCAAwC,EAAE,mBAAmB;EAC/D;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;MACI,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;MACI,kCAAkC;MAClC,YAAY;MACZ,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,iCAAiC;EACrC;;EAEA;MACI,wCAAwC;EAC5C;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB","sourcesContent":["/* RolesAndPermissions.css */\r\n.roles-permissions-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    padding: 20px;\r\n    background-color: rgba(0, 123, 255, 0.1); /* Прозрачный фон */\r\n  }\r\n  \r\n  .top-section {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n  \r\n  .roles-list-section,\r\n  .permissions-list-section {\r\n    width: 30%;\r\n    padding-right: 10px;\r\n  }\r\n  \r\n  .role-details-section {\r\n    width: 40%;\r\n  }\r\n  \r\n  .section-header {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin-bottom: 10px;\r\n  }\r\n  \r\n  .section-header h2 {\r\n    color: rgb(0, 123, 255);\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .create-button {\r\n      background-color: rgb(0, 123, 255);\r\n      color: white;\r\n      border: none;\r\n      padding: 8px 15px;\r\n      cursor: pointer;\r\n      border-radius: 4px;\r\n      transition: background-color 0.3s;\r\n  }\r\n  \r\n  .create-button:hover {\r\n      background-color: rgba(0, 123, 255, 0.8);\r\n  }\r\n  \r\n  .user-role-assignment-section {\r\n    width: 100%;\r\n    margin-top: 20px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
